import _GoogleDrive from '@uppy/google-drive';
import _Dropbox from '@uppy/dropbox';
import _Facebook from '@uppy/facebook';
import _Instagram from '@uppy/instagram';
import _Audio from '@uppy/audio';
import _Url from '@uppy/url';
import _Webcam from '@uppy/webcam';
import CompanionConfig from './CompanionConfig';
import FileTypesConfig from './FileTypesConfig';
import { uniq } from '../../utils/helpers'; // ProviderConfig returns uppy plugins and their configuration based on passed props

var sourceMap = {
  GoogleDrive: function GoogleDrive() {
    return 'GoogleDrive';
  },
  Dropbox: function Dropbox() {
    return 'Dropbox';
  },
  Facebook: function Facebook() {
    return 'Facebook';
  },
  Instagram: function Instagram() {
    return 'Instagram';
  },
  Url: function Url() {
    return 'Url';
  },
  Video: function Video(opts) {
    if (opts.extensions.filetypes.includes('video')) {
      opts.modes.push('video-audio');
      return 'Webcam';
    }

    return null;
  },
  Audio: function Audio(opts) {
    if (opts.extensions.filetypes.includes('audio')) {
      return 'Audio';
    }

    return null;
  },
  Webcam: function Webcam(opts) {
    if (opts.extensions.filetypes.includes('image')) {
      opts.modes.push('picture');
      return 'Webcam';
    }

    return null;
  }
};

function WebcamConfig(modes) {
  return {
    countdown: false,
    modes: modes,
    mirror: true,
    videoConstraints: {
      facingMode: 'user',
      width: {
        min: 720,
        ideal: 1280,
        max: 1920
      },
      height: {
        min: 480,
        ideal: 800,
        max: 1080
      }
    },
    showRecordingLength: false,
    preferredVideoMimeType: null,
    preferredImageMimeType: null,
    locale: {}
  };
}

var sourceConfigMap = {
  GoogleDrive: function GoogleDrive(opts) {
    return [_GoogleDrive, opts.companionConfig];
  },
  Dropbox: function Dropbox(opts) {
    return [_Dropbox, opts.companionConfig];
  },
  Facebook: function Facebook(opts) {
    return [_Facebook, opts.companionConfig];
  },
  Instagram: function Instagram(opts) {
    return [_Instagram, opts.companionConfig];
  },
  Url: function Url(opts) {
    return [_Url, opts.companionConfig];
  },
  Webcam: function Webcam(opts) {
    return [_Webcam, WebcamConfig(opts.modes)];
  },
  Audio: function Audio() {
    return [_Audio, {}];
  }
};

var ProviderConfig = function ProviderConfig() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var rawSources = props.sources;
  var sources = [];
  var sourcesConfig = [];

  if (rawSources !== null && rawSources !== void 0 && rawSources.length) {
    var opts = {
      companionConfig: CompanionConfig(props),
      modes: [],
      extensions: FileTypesConfig(props)
    };
    sources = uniq(rawSources.map(function (s) {
      return sourceMap[s](opts);
    })).filter(function (item) {
      return item;
    });
    sourcesConfig = sources.map(function (s) {
      return sourceConfigMap[s](opts);
    });
  }

  return {
    pluginsProp: sources,
    plugins: sourcesConfig
  };
};

export default ProviderConfig;